import { Typography } from "@mui/material";

export const H5Component = ({ text }: { text: string }) => {
  return (
    <Typography
      component="h6"
      sx={{
        color: "#024760",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "24px",
      }}
    >
      {text}
    </Typography>
  );
};
